module.exports = __webpack_public_path__ + "img/program-neostart.ec45e21d.jpg";